import { render, staticRenderFns } from "./tb.vue?vue&type=template&id=dce9f084&scoped=true"
import script from "./tb.vue?vue&type=script&lang=js"
export * from "./tb.vue?vue&type=script&lang=js"
import style0 from "./tb.vue?vue&type=style&index=0&id=dce9f084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce9f084",
  null
  
)

export default component.exports